import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/ComparisonTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/HeroHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Locations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Parallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/VideoHero2.tsx");
